const _ = require('lodash');
const slotId = require('../../../slotId');
const SearchService = function SearchService($q, Restangular, $state, $stateParams, $window, $Location, searchMultisearchService, RRPubSub, filtersService, decorateAdditionalDetails, $log, settingsService, breakpointsService, cacheService, anonymousUserIdService, $rootScope) {
    this.$q = $q;
    this._api = Restangular.one('Search');
    this._apiWithHeaders = Restangular.withConfig(function (RestangularConfigurer) {
        RestangularConfigurer.setFullResponse(true);
    }).one('Search');
    this._state = $state;
    this.restangular = Restangular;
    this._location = $Location;
    this._window = $window;
    this.multisearchService = searchMultisearchService;
    this.filtersService = filtersService;
    this.corrections = [];
    this.settingsService = settingsService;
    this.breakpointsService = breakpointsService;
    this.categories = [];
    this.SearchCount = {};
    this.resultsCount = 0;
    this.currentSearchOptionId = '';
    this.invalidateCategories = false;
    this.$stateParams = $stateParams;
    this._decorator = decorateAdditionalDetails;
    this.$log = $log;
    this.currentPageNumber = 1;
    this.sortType = '';
    this.cacheService = cacheService;
    this.isRedirecting = false;
    this.anonymousUserIdService = anonymousUserIdService;
    this.SponsoredAdsSlimBannerWidth = '';
    this.SponsoredAdsSlimBannerHeight = '';

    this.previous = {
        type: '',
        term: ''
    };

    this.rrPubSub = RRPubSub;
    this.getSiteManagementSettings();

    this.aiSuggestionBox = {
        isActive: true,
        isSearchIconClicked: false,
        isVisible: false
    };

    this.setAutoSuggestTopPosition = function (value) {
        $rootScope.$broadcast('updateAutoSuggestTopPos', value);
    };
};

SearchService.prototype.setAIBoxActive = function () {
    this.aiSuggestionBox.isActive = true;
};

SearchService.prototype.setAIBoxInActive = function () {
    this.aiSuggestionBox.isActive = false;
};

SearchService.prototype.setAIBoxVisibility = function (value) {
    this.aiSuggestionBox.isVisible = value;
    if (!value) {
        this.setAutoSuggestTopPosition(value);
    }
};

SearchService.prototype.setSearchIconClicked = function () {
    this.aiSuggestionBox.isSearchIconClicked = true;
};

SearchService.prototype.resetSearchIconClick = function () {
    this.aiSuggestionBox.isSearchIconClicked = false;
};

SearchService.prototype.getAIBoxVisibility = function () {
    return !this.aiSuggestionBox.isSearchIconClicked ? (this.aiSuggestionBox.isVisible && this.aiSuggestionBox.isActive) : false;
};

SearchService.prototype.getSiteManagementSettings = function () {
    const self = this;
    this.$q.all({
        toggleSponsoredAds: this.settingsService.getSettingValue('SponsoredAd', 'EnableSponsoredAds'),
        browseCountFill: this.settingsService.getSettingValue('SponsoredAd', 'SponsoredAdsBrowseCountFill'),
        searchCountFill: this.settingsService.getSettingValue('SponsoredAd', 'SponsoredAdsSearchCountFill'),
        toggleSlimBanner: this.settingsService.getSettingValue('SponsoredAd', 'EnableSponsoredSlimBannerAds'),
        toggleFeatureTile: this.settingsService.getSettingValue('SponsoredAd', 'EnableSponsoredFeatureTilesAds'),
        enableSponsorAdsEndpoint: this.settingsService.getSettingValue('SponsoredAd', 'EnableSponsorAdsEndpoint'),
    }).then(function (result) {
        self.enableSponsoredAds = result.toggleSponsoredAds;
        self.sponsoredAdsBrowseCountFill = result.browseCountFill;
        self.sponsoredAdsSearchCountFill = result.searchCountFill;
        self.enableSponsoredSlimBannerAds = result.toggleSlimBanner;
        self.enableSponsoredFeatureTileAds = result.toggleFeatureTile;
        self.enableSponsorAdsEndpoint = result.enableSponsorAdsEndpoint ? result.enableSponsorAdsEndpoint : false;
    });
};

SearchService.prototype.saveCurrentSearchOption = function (id) {
    this.currentSearchOptionId = id;
};

SearchService.prototype.getSearchOptionId = function () {
    const previousId = this.currentSearchOptionId;
    this.currentSearchOptionId = '';
    return previousId;
};

SearchService.prototype.determineStateToShow = function (searchTerm, multisearchItems) {
    if (searchTerm.toLowerCase().indexOf('recipe') > -1) {
        if (this.SearchCount.RecipeCount > 0) {
            return {
                name: 'shop.search.recipes',
                params: {
                    searchTerm,
                    multisearchItems
                }
            };
        } else if (this.SearchCount.ProductCount > 0) {
            return {
                name: 'shop.search.products',
                params: {
                    searchTerm,
                    multisearchItems,
                    id: undefined,
                    name: undefined,
                    aisle: undefined,
                    category: undefined
                }
            };
        } else if (this.SearchCount.ArticleCount > 0) {
            return {
                name: 'shop.search.articles',
                params: {
                    searchTerm,
                    multisearchItems
                }
            };
        }

        return {
            name: 'shop.search.zero-result',
            params: {
                searchTerm,
                multisearchItems
            }
        };
    }

    if (this.SearchCount.ProductCount > 0) {
        return {
            name: 'shop.search.products',
            params: {
                searchTerm,
                multisearchItems,
                id: undefined,
                name: undefined,
                aisle: undefined,
                category: undefined
            }
        };
    } else if (this.SearchCount.ArticleCount > 0) {
        return {
            name: 'shop.search.articles',
            params: {
                searchTerm,
                multisearchItems
            }
        };
    }

    return {
        name: 'shop.search.zero-result',
        params: {
            searchTerm,
            multisearchItems
        }
    };
};

SearchService.prototype.getCounts = function (searchTerm, isMultisearch) {
    if (searchTerm !== this.previous.term) {
        this.SearchCount.loadingCount = true;
        this.getSearchCounts(searchTerm, isMultisearch);
    }
};

SearchService.prototype.ifResetIsRequired = function (searchType, searchTerm) {
    return this.previous.type !== searchType || this.previous.term !== searchTerm;
};

SearchService.prototype.verifyAndReset = function (searchType, searchTerm) {
    if (this.ifResetIsRequired(searchType, searchTerm)) {
        this.resetResults();
        this.previous.term = searchTerm;
        this.previous.type = searchType;
        this.invalidateCategories = true;
    } else {
        this.invalidateCategories = false;
    }
};

SearchService.prototype.resetResults = function () {
    this.corrections = [];
    this.categories = [];
    this.resultsCount = 0;
};

SearchService.prototype.resetPrevious = function () {
    this.previous = {
        type: '',
        term: ''
    };
};

SearchService.prototype.resetCounts = function () {
    this.SearchCount = {
        ProductCount: 0,
        SpecialProductCount: 0,
        RecipeCount: 0,
        ArticleCount: 0
    };
};

SearchService.prototype.getSearchSuggestion = function (searchTerm) {
    return this._api.one('suggestion').get({
        Key: searchTerm
    });
};

SearchService.prototype.getSearchCounts = function (searchTerm, isMultisearch) {
    const self = this;
    return this._api.one('count').get({
        SearchTerm: searchTerm,
        IsMultisearch: isMultisearch
    }).then(function (data) {
        self.SearchCount = data.SearchCount;
    }).finally(function () {
        self.SearchCount.loadingCount = false;
    });
};

const checkSlotId = function (breakpointMobile, searchType) {
    if (breakpointMobile) {
        return {
            inferredBrandSlotId: slotId.slotId.inferredBrandMobile.slot,
            featureTileSlotId: slotId.slotId[searchType].FeatureTileMobile.slot,
            sponsoredProductSlotId: slotId.slotId[searchType].GridMobile.slot,
            slimBannerSponsoredProductSlotId: slotId.slotId[searchType].SlimBannerMobile.slot
        };
    } else {
        return {
            inferredBrandSlotId: slotId.slotId.inferredBrandDesktop.slot,
            featureTileSlotId: slotId.slotId[searchType].FeatureTileDesktop.slot,
            sponsoredProductSlotId: slotId.slotId[searchType].GridDesktop.slot,
            slimBannerSponsoredProductSlotId: slotId.slotId[searchType].SlimBannerDesktop.slot
        };
    }
};

const widthAndHeight = {
    large: {
        width: '970',
        height: '90'
    },
    medium: {
        width: '728',
        height: '90'
    },
    small: {
        width: '320',
        height: '50'
    }
};

let categoryCache = {};

SearchService.prototype.searchByCategory = function (request) {
    const self = this;
    const anonymousUserId = this.anonymousUserIdService.getAnonymousId();
    const checkSlotIdDeviceBrowse = checkSlotId(this.breakpointsService.isInSmallFormat, 'browse');
    const checkSlotIdDeviceSearch = checkSlotId(this.breakpointsService.isInSmallFormat, 'search');
    const isBrandPage = this._location.url().indexOf('/brand/') !== -1; //Applicable only for Browse call

    _.map(request, function (value, key) {
        if (key === 'department' || key === 'subDepartment' || key === 'category' || key === 'subCategory') {
            request[key] = value ? value.replace(/-/g, ' ') : value;
        }

        if (self.enableSponsoredAds || self.enableSponsoredSlimBannerAds) {
            // Request for PIQ
            request.pageType = 'Category';
            request.enableSponsoredAds = self.enableSponsoredAds && !self.enableSponsorAdsEndpoint && !isBrandPage;
            request.sponsoredAdsSlot = self.isRedirecting ? checkSlotIdDeviceSearch.sponsoredProductSlotId : checkSlotIdDeviceBrowse.sponsoredProductSlotId;
            request.sponsoredAdsSession = anonymousUserId;
            request.sponsoredAdsCountFill = self.sponsoredAdsBrowseCountFill;
            request.enableSponsoredSlimBannerAds = self.enableSponsoredSlimBannerAds && !self.enableSponsorAdsEndpoint && !isBrandPage;
            request.sponsoredAdsSlimBannerSlot = self.isRedirecting ? checkSlotIdDeviceSearch.slimBannerSponsoredProductSlotId : checkSlotIdDeviceBrowse.slimBannerSponsoredProductSlotId;
            request.tilesPerRow = window.innerWidth >= 1200 ? 5 : window.innerWidth >= 992 ? 4 : window.innerWidth >= 768 ? 3 : 2;
            if (self.breakpointsService.isInLargeFormat) {
                request.sponsoredAdsSlimBannerWidth = widthAndHeight.large.width;
                request.sponsoredAdsSlimBannerHeight = widthAndHeight.large.height;
                request.sponsoredAdsSlimBannerIndex = 10;
            } else if (self.breakpointsService.isInMediumFormat) {
                request.sponsoredAdsSlimBannerWidth = widthAndHeight.medium.width;
                request.sponsoredAdsSlimBannerHeight = widthAndHeight.medium.height;
                request.sponsoredAdsSlimBannerIndex = 8;
            } else if (self.breakpointsService.isInSmallFormat) {
                request.sponsoredAdsSlimBannerWidth = widthAndHeight.small.width;
                request.sponsoredAdsSlimBannerHeight = widthAndHeight.small.height;
                request.sponsoredAdsSlimBannerIndex = 4;
            }
        }

        if (self.enableSponsoredFeatureTileAds) {
            request.enableSponsoredFeatureTileAds = self.enableSponsoredFeatureTileAds && !self.enableSponsorAdsEndpoint && !isBrandPage;
            request.SponsoredAdsFeatureTileSlot = self.isRedirecting ? checkSlotIdDeviceSearch.featureTileSlotId : checkSlotIdDeviceBrowse.featureTileSlotId;
            request.SponsoredAdsFeatureTileWidth = window.innerWidth < 430 ? 441 : 457;
            request.SponsoredAdsFeatureTileHeight = 526;
            request.deviceType = window.innerWidth >= 1200 ? 'large-desktop' : window.innerWidth >= 992 ? 'desktop' : window.innerWidth >= 768 ? 'tablet' : 'mobile';
        }

        if (self.isRedirecting) {
            request.redirectedFrom = self.previous.term;
        }
    });

    const cleanResponse = (data) => {
        this.filtersService.filters = data.Aggregations;
        this.filtersService.seoTags = data.SeoMetaTags;
        if (request.pageNumber <= 1) {
            this.filtersService.resultCount = data.TotalRecordCount || 0;
        }
        if (request.pageNumber === 1 && self.invalidateCategories) {
            this.resultsCount = data.TotalRecordCount || 0;
            this.filtersService.resultCount = data.TotalRecordCount || 0;
        }
        return data;
    };

    const createObj = (data, request) => {

        if (self.isRedirecting) {
            if (data && data.Bundles && data.Bundles.length > 0) {
                data.Bundles.forEach((product) => {
                    product.Products[0].searchTerm = self.previous.term;
                })
            }

            if (data && data.SponsoredAds) {
                if (data.SponsoredAds.FeatureTiles && Object.keys(data.SponsoredAds.FeatureTiles).length > 0) {
                    _.forEach(data.SponsoredAds.FeatureTiles, function (featureTile) {
                        featureTile[0].searchTerm = self.previous.term;
                    });
                }

                if (data.SponsoredAds.Banners && Object.keys(data.SponsoredAds.Banners).length > 0) {
                    _.forEach(data.SponsoredAds.Banners, function (Banner) {
                        Banner[0].searchTerm = self.previous.term;
                    });
                }
            }
        }

        self.isRedirecting = false;

        if (self.enableSponsorAdsEndpoint && !isBrandPage) {
            data.SponsoredAds = null;
            request.OrganicProductCount = (data.Bundles && data.Bundles.length) > 0 ? data.Bundles.length : 0;
            request.enableSponsoredAds = (this.currentPageNumber > 1 || (request.sortType && request.sortType.toLowerCase().indexOf('relevance') < 0)) 
                ? false : self.enableSponsoredAds;
            request.enableSponsoredFeatureTileAds = self.enableSponsoredFeatureTileAds;
            request.enableSponsoredSlimBannerAds = self.enableSponsoredSlimBannerAds;
        
            return self.getSponsoredAds(request).then(function (response) {
                data.SponsoredAds = response;
                return mapBrowseResponseObject(data, request);
            });
        } else {
            return mapBrowseResponseObject(data, request);
        }
    };

    const mapBrowseResponseObject = (data, request) => {
        //to check sponsored ads data present or not
        self.saveBannerAds(data.SponsoredAds.Banners, request.pageNumber);
        self.featureTileAds(data.SponsoredAds.FeatureTiles, request.pageNumber);

        return {
            items: data.Bundles,
            totalRecordCount: data.TotalRecordCount + data.SponsoredAds.Ads.length,
            categoryId: data.LeafCategoryId,
            ads: data.SponsoredAds.Ads || {},
            Categories: data.Categories.Categories || [],
            featureTiles: data.SponsoredAds.FeatureTiles || {}
        };
    }

    // save the current page
    this.currentPageNumber = request.pageNumber;
    this.sortType = request.sortType;
    // disable request ads if the sort is other than relevance
    if (this.currentPageNumber > 1 || (request.sortType && request.sortType.toLowerCase().indexOf('relevance') < 0)) {
        request.enableSponsoredAds = false;
    }

    //Only perform and return a POST if we are filtering
    if (request.filters && request.filters.length) {
        return this.restangular.one('/').post('Browse', request).then((data) => {
            return cleanResponse(data);
        }).then(function (data) {
            return createObj(data, request);
        }).catch((error) => {
            self.isRedirecting = false;
        });
    }

    //Else perform and return a GET
    return this.restangular.one('/Browse').get(request).then((data) => {
        return cleanResponse(data);
    }).then(function (data) {
        return createObj(data, request);
    }).catch((error) => {
        self.isRedirecting = false;
    });
};

SearchService.prototype.saveBannerAds = function (bannerDatas, pageNumber) {
    if (pageNumber === 1) {
        const currentUrl = this._state.href(this._state.current.name, this._state.params, { absolute: true });
        this.cacheService.setBannerCache(currentUrl, bannerDatas);

        if (bannerDatas && Object.keys(bannerDatas).length > 0) {
            const trackerUrls = [];
            _.forEach(bannerDatas, function (bannerData) {
                trackerUrls.push(bannerData[0].ImpressionTracker);
            });
            this.setupImpressionTracking(trackerUrls, '.card-list-item.is-Sponsored');
        }
    }
};

SearchService.prototype.featureTileAds = function (tileData, pageNumber) {
    if (tileData && Object.keys(tileData).length > 0 && pageNumber === 1) {
        const trackerUrls = [];
        _.forEach(tileData, function (featureCard) {
            trackerUrls.push(featureCard[0].ImpressionTracker);
        });
        trackerUrls.reverse();
        this.setupImpressionTracking(trackerUrls, '.featureCard.card');
    }
};

SearchService.prototype.removeCategoryCache = function (key) {
    if (_.isUndefined(key)) categoryCache = {};
    delete categoryCache[key];
};

SearchService.prototype.doSearch = function (searchTerm, pageSize, pageNumber, sortType, isSpecial, filters, banner) {
    this.getCounts(searchTerm, this.multisearchService.isSearchMultisearch());
    this.verifyAndReset('products', searchTerm);
    const self = this;
    this.previous.term = searchTerm;
    const anonymousUserId = this.anonymousUserIdService.getAnonymousId();
    const checkSlotIdDevice = checkSlotId(this.breakpointsService.isInSmallFormat, 'search');

    // save the current page
    this.currentPageNumber = pageNumber;
    let sponsoredAdsSlimBannerWidth;
    let sponsoredAdsSlimBannerHeight;
    let sponsoredAdsSlimBannerIndex;

    sortType = sortType === undefined ? 'Relevance' : sortType;
    this.sortType = sortType;

    if (self.breakpointsService.isInLargeFormat) {
        sponsoredAdsSlimBannerWidth = widthAndHeight.large.width;
        sponsoredAdsSlimBannerHeight = widthAndHeight.large.height;
        sponsoredAdsSlimBannerIndex = 10;
    } else if (self.breakpointsService.isInMediumFormat) {
        sponsoredAdsSlimBannerWidth = widthAndHeight.medium.width;
        sponsoredAdsSlimBannerHeight = widthAndHeight.medium.height;
        sponsoredAdsSlimBannerIndex = 8;
    } else if (self.breakpointsService.isInSmallFormat) {
        sponsoredAdsSlimBannerWidth = widthAndHeight.small.width;
        sponsoredAdsSlimBannerHeight = widthAndHeight.small.height;
        sponsoredAdsSlimBannerIndex = 4;
    }

    const mapSearchResponseObject = (res) => {
        this.saveBannerAds(res.data.SponsoredAds.Banners, pageNumber);
        this.featureTileAds(res.data.SponsoredAds.FeatureTiles, pageNumber);

        return {
            items: res.data.Products,
            totalRecordCount: res.data.SearchResultsCount + res.data.SponsoredAds.Ads.length,
            ads: res.data.SponsoredAds.Ads,
            eventId: res.headers('x-eventid'),
            featureTiles: res.data.SponsoredAds.FeatureTiles || {}
        };
    };

    this.isRedirecting = false;
    const isInferredBrand = self && self._window && self._window.isInferredBrandRM ? self._window.isInferredBrandRM === true : false;
    const request = {
        SearchTerm: searchTerm.replace(/\-/g, ' '),
        PageSize: pageSize,
        PageNumber: pageNumber,
        SortType: sortType,
        IsSpecial: isSpecial,
        Location: banner === true ? 'searchTerm=' + this.$stateParams.searchTerm + '&filters=' + this.$stateParams.filters : undefined,
        IsMultisearch: self.multisearchService.isSearchMultisearch(),
        Filters: filters || undefined,
        EnableSponsoredAds: this.currentPageNumber === 1 && sortType.toLowerCase().indexOf('relevance') >= 0 ? self.enableSponsoredAds && !self.enableSponsorAdsEndpoint : false,
        InferMajorityCategories: isInferredBrand,
        SponsoredAdsSlot: isInferredBrand ? checkSlotIdDevice.inferredBrandSlotId : checkSlotIdDevice.sponsoredProductSlotId,
        SponsoredAdsSession: anonymousUserId,
        SponsoredAdsCountFill: self.sponsoredAdsSearchCountFill,
        EnableSponsoredSlimBannerAds: self.enableSponsoredSlimBannerAds && !self.enableSponsorAdsEndpoint,
        EnableSponsoredFeatureTileAds: self.enableSponsoredFeatureTileAds && !self.enableSponsorAdsEndpoint,
        SponsoredAdsSlimBannerSlot: checkSlotIdDevice.slimBannerSponsoredProductSlotId,
        SponsoredAdsSlimBannerWidth: sponsoredAdsSlimBannerWidth,
        SponsoredAdsSlimBannerHeight: sponsoredAdsSlimBannerHeight,
        SponsoredAdsSlimBannerIndex: sponsoredAdsSlimBannerIndex,
        SponsoredAdsFeatureTileSlot: checkSlotIdDevice.featureTileSlotId,
        SponsoredAdsFeatureTileWidth: window.innerWidth < 430 ? 441 : 457,
        SponsoredAdsFeatureTileHeight: 526,
        TilesPerRow: window.innerWidth >= 1200 ? 5 : window.innerWidth >= 992 ? 4 : window.innerWidth >= 768 ? 3 : 2,
        DeviceType: window.innerWidth >= 1200 ? 'large-desktop' : window.innerWidth >= 992 ? 'desktop' : window.innerWidth >= 768 ? 'tablet' : 'mobile',
    };

    return this._apiWithHeaders.post('products', request).then((res) => {
        self.corrections = res.data.Corrections;
        self.filtersService.filters = res.data.Aggregations;
        if (self.invalidateCategories && res.data.VisualShoppingAisleResponse) {
            self.categories = res.data.VisualShoppingAisleResponse;
        }
        if (pageNumber <= 1) {
            this.filtersService.resultCount = res.data.SearchResultsCount || 0;
        }
        if (pageNumber === 1 && self.invalidateCategories) {
            self.resultsCount = res.data.SearchResultsCount || 0;
        }
        return res;

    }).then((res) => {
        try {
            if (pageNumber === 1) {
                searchTerm = searchTerm.replace(/-/g, ' ');
                self.rrPubSub.publish(self.rrPubSub.EVENTS.PAGING_SEARCH, {
                    searchTerm,
                    items: res.data.Products
                });
            }
        } catch (error) {
            console.error(error);
        }

        _.each(res.data.Products, (bundle) => {
            this._decorator(bundle.Products);
        });

        if (self.enableSponsorAdsEndpoint) {
            res.data.SponsoredAds = null;
            const organicProductCount = (res.data && res.data.Products && res.data.Products.length > 0) ? res.data.Products.length : 0;
            request.OrganicProductCount = organicProductCount;
            let stockCode = [];
            if (organicProductCount > 0) {
                _.forEach(res.data.Products, function (product, index) {
                    stockCode[index] = product.Products[0].Stockcode;
                });
            }
            request.Targets = { "MatchProducts": stockCode };
            request.EnableSponsoredAds = this.currentPageNumber === 1 && sortType.toLowerCase().indexOf('relevance') >= 0 ? self.enableSponsoredAds : false;
            request.EnableSponsoredSlimBannerAds = self.enableSponsoredSlimBannerAds;
            request.EnableSponsoredFeatureTileAds = self.enableSponsoredFeatureTileAds;
            return self.getSponsoredAds(request).then(function (response) {
                res.data.SponsoredAds = response;
                return mapSearchResponseObject(res);
            });
        } else {
            return mapSearchResponseObject(res);
        }

    }, (response) => {
        const action = response.data[0];
        if (!action) return;

        self.isRedirecting = true;

        if (action.ActionType.toLowerCase() === 'promptlogin') {
            self._state.go('shop.authentication.login', {}, { reload: true });
        } else {
            try {
                // change absolute url navigation to relative if navigation to bws website
                const bwsDomain = 'bws.com.au';
                if (action.RedirectUrl.indexOf(bwsDomain) !== -1) {
                    action.RedirectUrl = action.RedirectUrl.split(bwsDomain)[1];
                    if (action.RedirectUrl.indexOf('searchTerm') === -1) {
                        this._location.search('searchTerm', null);
                    }
                    this._location.path(action.RedirectUrl);
                } else {
                    self._window.open(action.RedirectUrl, action.RedirectTarget === 'Self' ? '_self' : '_blank');
                }
            } catch (e) {
                self._window.open(action.RedirectUrl, action.RedirectTarget === 'Self' ? '_self' : '_blank');
            }
        }
    });
};

SearchService.prototype.getSponsoredAds = function (request) {
    return this.restangular.one('/').post('Browse/SponsoredAds', request).then((data) => {
        return data;
    }).catch((error) => {
        self.isRedirecting = false;
    });
}

SearchService.prototype.doMultisearch = function (searchterm, multisearchItems) {
    const self = this;
    const emptyParams = {
        productId: undefined,
        recipeId: undefined,
        cardId: undefined,
        name: undefined,
        pageNumber: undefined,
        IsMultisearch: true
    };
    self.getSearchCounts(searchterm, true).then(function () {
        const nextState = self.determineStateToShow(searchterm, multisearchItems);
        self._state.go(nextState.name, _.assign(emptyParams, nextState.params));
    });
};

SearchService.prototype.predictiveSearch = function (searchTerm) {
    return this._apiWithHeaders.one('Suggestion').get({
        Key: searchTerm
    }).then((response) => {
        this._decorator(response.data.Products.Suggestions);
        return response;
    });
};

SearchService.prototype.transformProductsToDefault = function (products, isProductGroup, ads) {

    const defaultProducts = [];
    const parentProducts = [];
    const excludedProductStockcodes = [];

    //Create the default products array
    _.forEach(products, (value) => {
        const parentProduct = _.find(value.Products, { Stockcode: value.PackParentStockCode });
        const defaultProduct = _.find(value.Products, { Stockcode: value.PackDefaultStockCode });

        // We need a way to distinguish between a regular product and a product in a product group
        if (isProductGroup && defaultProduct) {
            defaultProduct.isProductGroup = true;
        }

        if (parentProduct && defaultProduct) {
            try {
                this.setProductDetails(parentProduct, defaultProduct, value);

                parentProducts.push(parentProduct);
                defaultProducts.push(defaultProduct);
            } catch (e) {
                this.$log.log('Product data error');
                this.$log.log(value);
            }
        } else {
            const missingData = defaultProduct ? 'PackParent' : 'Default';
            excludedProductStockcodes.push(value.PackDefaultStockCode);
            this.$log.log(missingData + ' product not found');
            this.$log.log(value);
        }
    });

    // remove the product from the original list as well when they aren't pushed to either parentProducts or defaultProducts.
    _.forEach(excludedProductStockcodes, (stockcode) => {
        _.remove(products, function (p) {
            return (p.PackDefaultStockCode === stockcode);
        });
    });

    this.sortType = this.sortType || '';

    if (this.sortType.toLowerCase().indexOf('relevance') >= 0) {
        // not necessary to call the below methods from 2nd page, as ads don't exist
        if (this.currentPageNumber === 1) {
            if (ads && ads.length > 0) {
                this.mergeAdsToDefaultProducts(products, defaultProducts, ads);
            }
        } else {
            // remove the products that are already loaded as part of ads
            const adsStockcodes = _.clone(this.settingsService.getAdsStockCodes());

            _.forEach(adsStockcodes,
                (stockcode) => {
                    // remove from bundles list
                    const product = _.remove(products,
                        function (p) {
                            return (p.PackParentStockCode === stockcode);
                        });
                    if (product.length > 0) {
                        // remove from default products list
                        _.remove(defaultProducts,
                            function (p) {
                                return (p.Stockcode === product[0].PackDefaultStockCode);
                            });

                        // update the global list if it exists
                        this.settingsService.removeAdsStockCode(stockcode);
                    }
                });
        }
    }

    return defaultProducts;
};

SearchService.prototype.setProductDetails = function (parentProduct, defaultProduct, value) {
    if (!parentProduct.ProductData) {
        this._decorator([parentProduct]);
    }
    //Replace the default product's BrandName, Title, NumberOfReviews and OverallRating properties from the parent product
    defaultProduct.BrandName = parentProduct.ProductData.brandName || parentProduct.ProductData.BrandName;
    defaultProduct.Title = parentProduct.ProductData.title || parentProduct.ProductData.Title;
    defaultProduct.NumberOfReviews = parentProduct.NumberOfReviews;
    defaultProduct.OverallRating = parentProduct.OverallRating;
    defaultProduct.hidePrice = parentProduct.ProductData.hideprice;
    defaultProduct.displayOnly = parentProduct.ProductData.displayonly;
    defaultProduct.featured = parentProduct.ProductData.featured;
    defaultProduct.PackDefaultStockCode = value.PackDefaultStockCode;
    defaultProduct.PackParentStockCode = value.PackParentStockCode;
};

SearchService.prototype.mergeAdsToDefaultProducts = function (bundles, defaultProducts, ads) {
    if (!ads) return;
    const adsStockcodes = [];
    const trackerUrls = [];
    const isSponsored = ads[0].Bundle.IsSponsored;

    for (let i = ads.length - 1; i >= 0; i--) {
        const ad = ads[i];
        if (ad.Bundle.IsSponsored) {
            trackerUrls.push(ad.ImpressionTracker);
        }
        // bring the ad products to the top in sequence
        // the ads will be ordered by their relevance and they should be displayed in the same order.
        const adBundle = _.remove(bundles, function (p) {
            return (p.PackParentStockCode === ad.Bundle.PackParentStockCode);
        });
        if (adBundle.length > 0) {
            const adToPushDefaultProduct = _.remove(defaultProducts, function (p) {
                return (p.Stockcode === adBundle[0].PackDefaultStockCode);
            });
            // re-order the product in the default list
            // For PIQ
            if (isSponsored) {
                adToPushDefaultProduct[0].IsSponsored = ad.Bundle.IsSponsored;
                adToPushDefaultProduct[0].ClickTracker = ad.ClickTracker;
                adToPushDefaultProduct[0].CampaignId = ad.CampaignId;
            }

            defaultProducts.splice(0, 0, adToPushDefaultProduct[0]);

            _.forEach(adBundle[0].Products, p => {
                // For PIQ
                if (isSponsored) {
                    p.IsSponsored = ad.Bundle.IsSponsored;
                    p.ClickTracker = ad.ClickTracker;
                }
            });
            // re order parent list as well.
            bundles.splice(0, 0, adBundle[0]);
        } else {
            this._decorator(ad.Bundle.Products);
            const adToPush = _.find(ad.Bundle.Products, { Stockcode: ad.Bundle.PackDefaultStockCode });
            const parentProduct = _.find(ad.Bundle.Products, { Stockcode: ad.Bundle.PackParentStockCode });

            if (adToPush && parentProduct) {
                // this count is incremented for only the ads that are pushed as new products, for existing products ignore the count.
                adsStockcodes.push(ad.Bundle.PackParentStockCode);
                this.setProductDetails(parentProduct, adToPush, ad.Bundle);
                // For PIQ
                if (isSponsored) {
                    adToPush.IsSponsored = ad.Bundle.IsSponsored;
                    adToPush.ClickTracker = ad.ClickTracker;
                }

                defaultProducts.splice(0, 0, adToPush);

                _.forEach(ad.Bundle.Products, p => {
                    // For PIQ
                    if (isSponsored) {
                        adToPush.IsSponsored = ad.Bundle.IsSponsored;
                        adToPush.ClickTracker = ad.ClickTracker;
                    }
                });
                // re order parent list.
                bundles.splice(0, 0, ad.Bundle);
            }
        }
    }
    this.settingsService.setAdsStockCodes(adsStockcodes);
    // Setup impression tracking for PIQ
    if (isSponsored) {
        trackerUrls.reverse();
        this.setupImpressionTracking(trackerUrls, '.productTile.is-Sponsored');
    }
};

// impression tracking for PIQ
SearchService.prototype.setupImpressionTracking = function (trackerUrls, tileType) {
    if (trackerUrls.length === 0) {
        return;
    }

    let timerIds = Array(trackerUrls.length);
    let removeTickCount = 0;
    // eslint-disable-next-line no-undef
    const intersectionObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            let trackingIndex = entry.target.getAttribute('impression-index');
            if (entry.isIntersecting) {
                timerIds[trackingIndex] = setTimeout(() => {
                    fetch(trackerUrls[trackingIndex]);
                    entry.target.removeAttribute('impression-index');
                    intersectionObserver.unobserve(entry.target);
                }, 1000);
            } else if (timerIds[trackingIndex]) {
                clearTimeout(timerIds[trackingIndex]);
            }
        });
    }, { threshold: 0.5 });

    const triggerTracking = function () {
        document.querySelectorAll(tileType).forEach((element, index) => {
            element.setAttribute('impression-index', index);
            intersectionObserver.observe(element);
        });
    };

    const pageIntersectionObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            let pageTrackingIndex = entry.target.getAttribute('page-impression-index');
            fetch(trackerUrls[pageTrackingIndex]);
            entry.target.removeAttribute('page-impression-index');
            pageIntersectionObserver.unobserve(entry.target);
        });
    }, { threshold: 0.5 });

    const pageLoadTracking = function () {
        document.querySelectorAll(tileType).forEach((element, index) => {
            element.setAttribute('page-impression-index', index);
            pageIntersectionObserver.observe(element);
        });
    };

    const myTimer = setInterval(() => {
        removeTickCount++;
        if (document.querySelectorAll(tileType).length) {
            pageLoadTracking();
            // Due to business requirement, commenting out the below function temporarily
            // Bcoz source code is required, to enable after three weeks
            // triggerTracking();
            clearInterval(myTimer);
        } else if (removeTickCount > 5) {
            clearInterval(myTimer);
        }
    }, 500);

};

SearchService.prototype.slimBannerClick = function (clickTracker) {
    fetch(clickTracker);
};

module.exports = SearchService;



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/search/search-service.js
 **/